module.exports = __webpack_public_path__ + "static/media/logout.dc7a5b88.png";